import { NotificationType } from '../../models';
import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';

export const getNotificationTypes: (
  fetchContext: FetchContext,
  accessToken?: string,
) => Promise<NotificationType[]> = (fetchContext, accessToken) => fetch(`${fetchContext.baseUrl}/api/notifications/types`,
  {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  })
  .then((response) => responseErrorHandler<NotificationType[]>(fetchContext.errorStore, response, 'get notification types'));
